import {Component, Injector, Input, OnDestroy, OnInit} from '@angular/core';
import {DetailsConfig, SharedUiDetailsModule } from '@snelstart/ui-details';
import {ButtonConfiguration, SharedUiButtonModule } from "@snelstart/ui-button";
import {Observable, Subject, takeUntil} from "rxjs";
import {
  BokkzAlgDataService,
  BokkzClient, DossierItemEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {ToastService} from "@snelstart/ui-toast";
import {FormBuilder} from "@angular/forms";
import {FeatureTasksItemComponent} from "../tasks-item/feature-tasks-item.component";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-tasks-details',
  templateUrl: './feature-tax-tasks-details.component.html',
  styleUrl: './feature-tax-tasks-details.component.scss',
  imports: [
    SharedUiDetailsModule,
    SharedUiButtonModule,
    FeatureTasksItemComponent,
  ],
})
export class FeatureTaxTasksDetailsComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  public clientId = {} as string;
  private destroy$ = new Subject<void>();
  public dossierItem = {} as DossierItemEntity;

  protected readonly detailsConfig = DetailsConfig.create({
    hideArrowButtons: false,
  });

  public configSave() {
    return ButtonConfiguration.create({
      onClick: () =>
        new Observable((subscription) => {
          setTimeout(() => {
            this.saveForm();
            subscription.next(true);
            subscription.complete();
          }, 200);
        }),
    });
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private injector: Injector,
    public toastService: ToastService,
    public fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.algDataService.workflowItem.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.dossierItem = value;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  saveForm(): void {
    const bokkzClient = this.injector.get(BokkzClient);
    bokkzClient
      .postDossierItem(String(this.clientId), this.dossierItem)
      .subscribe((dossierItemEntity) => {
        if (dossierItemEntity) {
          this.toastService.showSuccessMessage(
            'Het dossier item is succesvol opgeslagen.',
          );
        } else {
          this.toastService.showWarningMessage(
            'Het dossier item is niet succesvol omgezet.',
          );
        }
      });
  }
}
